// Byte encodings shared by every crypto module.
import { base58, base64url, base64, hex } from "@scure/base";

export const utf8 = (s: string): Uint8Array => new TextEncoder().encode(s);
export const fromUtf8 = (b: Uint8Array): string => new TextDecoder().decode(b);

/** Unpadded base64url (RFC 7515 §2). */
export const b64u = (b: Uint8Array): string => base64url.encode(b).replace(/=+$/, "");
export function b64uDecode(s: string): Uint8Array {
  if (typeof s !== "string" || s.includes("=")) throw new Error("JWS segments are unpadded base64url");
  return base64url.decode(s + "=".repeat((4 - (s.length % 4)) % 4));
}

export const b58 = (b: Uint8Array): string => base58.encode(b);
export const b58Decode = (s: string): Uint8Array => base58.decode(s);
export const toHex = (b: Uint8Array): string => hex.encode(b);
export const fromHex = (s: string): Uint8Array => hex.decode(s.startsWith("0x") ? s.slice(2) : s);

/** Multibase: z (base58btc), u (base64url), m (base64). */
export function multibaseDecode(s: string): Uint8Array {
  if (s.startsWith("z")) return base58.decode(s.slice(1));
  if (s.startsWith("u")) return b64uDecode(s.slice(1));
  if (s.startsWith("m")) {
    const t = s.slice(1);
    return base64.decode(t + "=".repeat((4 - (t.length % 4)) % 4));
  }
  throw new Error(`unknown multibase prefix ${JSON.stringify(s.slice(0, 1))}`);
}

export function concat(...parts: Uint8Array[]): Uint8Array {
  const out = new Uint8Array(parts.reduce((n, p) => n + p.length, 0));
  let i = 0;
  for (const p of parts) { out.set(p, i); i += p.length; }
  return out;
}

export function equalBytes(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) return false;
  let d = 0;
  for (let i = 0; i < a.length; i++) d |= a[i] ^ b[i];
  return d === 0;
}
